module.exports = __webpack_public_path__ + "static/WEDDING E&M-172-ed291c4d6dd64b9a5edd570611eaa948.jpg";